import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomEncodeDecodeService {

  constructor() { }

  encode(val: any) {
    val = btoa(val.toString());
    while (val.indexOf("=") > -1) {
      val = val.replace("=", "ECDC");
    }
    return val;
  }

  decode(val: any) {
    if (val != null && val != undefined && val != '') {
      while (val.indexOf("ECDC") > -1) {
        val = val.replace("ECDC", "=");
      }
      val = atob(val);
      return val;
    }
  }

  decodeToInt(val: any) {
    if (val != null && val != undefined && val != '') {
      while (val.indexOf("ECDC") > -1) {
        val = val.replace("ECDC", "=");
      }
      val = atob(val);
      return parseInt(val);
    }
    return 0;
  }
}
